import {
  EyeIcon,
  LayoutGridIcon,
  SearchIcon,
  ActivityIcon,
} from "lucide-react";
import { useAssistantToolUI, useInlineRender } from "@assistant-ui/react";
import { ToolChip } from "./ToolChip";

export function GetPipelineToolUI() {
  useAssistantToolUI({
    toolName: "get_pipeline",
    render: useInlineRender(({ status }) => (
      <ToolChip
        icon={EyeIcon}
        runningVerb="Checking pipeline..."
        completeVerb="Checked pipeline"
        status={status}
        muted
      />
    )),
  });
  return null;
}

export function GetAvailableModulesToolUI() {
  useAssistantToolUI({
    toolName: "get_available_modules",
    render: useInlineRender(({ status }) => (
      <ToolChip
        icon={LayoutGridIcon}
        runningVerb="Listing modules..."
        completeVerb="Listed modules"
        status={status}
      />
    )),
  });
  return null;
}

export function GetNodeToolUI() {
  useAssistantToolUI({
    toolName: "get_node",
    render: useInlineRender(({ status }) => (
      <ToolChip
        icon={SearchIcon}
        runningVerb="Checking node..."
        completeVerb="Checked node"
        status={status}
        muted
      />
    )),
  });
  return null;
}

export function GetNodeOutputToolUI() {
  useAssistantToolUI({
    toolName: "get_node_output",
    render: useInlineRender(({ status }) => (
      <ToolChip
        icon={ActivityIcon}
        runningVerb="Checking output..."
        completeVerb="Checked output"
        status={status}
        muted
      />
    )),
  });
  return null;
}
